import { Checkbox as CheckboxA, CheckboxProps } from 'antd';

export const Checkbox = (props: CheckboxProps) => {
    return <CheckboxA {...props} />;
};
